<script setup lang="tsx">
import type { Response, VulnerabilityMeta } from '@/models/api-generated'
import http from '@/services/http'
import { ref } from 'vue'
import Multiselect from 'vue-multiselect'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const availableVulnerabilities = ref<VulnerabilityMeta[]>([])
const searchQuery = ref('')

const emit = defineEmits<{
	(e: 'select', vulnerability: VulnerabilityMeta): void
}>()

const props = defineProps<{
	exclude: number[]
}>()

const model = defineModel<VulnerabilityMeta | undefined>({ required: true })

async function search(query: string) {
	const { data } = await http.get<Response<VulnerabilityMeta[]>>('/api/vulnerability/search', {
		params: { q: query, exclude: props.exclude.join(',') },
	})
	availableVulnerabilities.value = data.data || []
}

function onSelect(vulnerability: VulnerabilityMeta) {
	emit('select', vulnerability)
}
</script>

<template>
	<Multiselect
		:multiple="false"
		:show-labels="false"
		:options="availableVulnerabilities"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		v-model="model"
		track-by="id"
		@search-change="search"
		@open="search(searchQuery)"
		@select="onSelect"
		:placeholder="t('misc.search') + '...'"
	>
		<template #option="{ option }">
			<span :data-test="'vulnerability-option-' + option.id"> {{ option.vulnerability.name }} ({{ option.vulnerability.code }}) </span>
		</template>
	</Multiselect>
</template>
